'use client';

import { MainLayout } from './MainLayout';

export function MarketingLayout({
  children,
  contentClassName = 'marketing-hero mt-6',
  globeOpacity,
  showGlobeBackground = true,
}: {
  children: React.ReactNode;
  contentClassName?: string;
  globeOpacity?: number;
  showGlobeBackground?: boolean;
}) {
  return (
    <MainLayout
      contentClassName={contentClassName}
      globeOpacity={globeOpacity}
      showGlobeBackground={showGlobeBackground}
    >
      {children}
    </MainLayout>
  );
}
